import * as React from 'react'
import type {SVGProps} from 'react'
const SvgPlus = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} viewBox="0 0 10 10" {...props}>
        <path fill="currentColor" fillRule="evenodd" d="M6 0v3.999L10 4v2H6v4H4V6H0V4h4V0z" />
    </svg>
)
export default SvgPlus
